import {
  ActiveFavouriteAction,
  DeleteAction,
  DownloadAction,
  EditAction,
  FavouriteAction,
  MoveAction,
  RestoreAction,
} from "../Components/DataTable";
import api from "../../../api/api";
import { invokePostApi } from "./utils";

export async function handleNameSubmit(selectedFile, token, newFileName) {
  if (!selectedFile) return;

  const payload = {
    item_type: selectedFile?.item_type,
    item_id: selectedFile?.id,
    new_name: newFileName?.trim(),
  };

  const response = await api.put("rename-item/", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Token ${token}`,
    },
  });

  if (response?.status === 200 || response?.status === 201) {
    return response.data; // return only data
  }

  throw new Error("Rename failed"); //  important for React Query
}

export async function handleFavourites(fileData, token) {
  if (!fileData) return;

  let payload;

  if (fileData?.id_array) {
    // Multiple items
    payload =
      fileData?.item_type === "file"
        ? { file_ids: fileData.id_array }
        : { folder_ids: fileData.id_array };
  } else {
    // Single item
    payload =
      fileData?.item_type === "file"
        ? { file_ids: [fileData.id] }
        : { folder_ids: [fileData.id] };
  }

  // Call API
  const response = await invokePostApi(
    token,
    "manual-upload/bulk-item-action/",
    payload,
    null,
  );

  if (response?.status === 200 || response?.status === 201) {
    // Return success for React Query to handle
    return response.data;
  }

  throw new Error("Favourite update failed");
}

export async function handleDelete(file, token, deleteType = "soft") {
  if (!file) return;

  const payload = Array.isArray(file)
    ? { id: file, type: "file", delete_type: deleteType }
    : { id: file?.id, type: "file", delete_type: deleteType };

  try {
    const deleteResponse = await invokePostApi(token, "delete/", payload, null);

    if (deleteResponse?.status === 200 || deleteResponse?.status === 201) {
      return { success: true, deleteType };
    }

    throw new Error("Delete failed");
  } catch (error) {
    throw error; // let the mutation handle the error
  }
}

export async function handleRestore(file, token) {
  if (!file) return;

  let payload;
  if (Array.isArray(file)) {
    payload = { type: "file", id: file };
  } else {
    payload = { type: file?.["item_type"] || "file", id: file?.id };
  }

  // Call API
  const response = await invokePostApi(token, "restore/", payload);

  if (response?.status === 200 || response?.status === 201) {
    // Return success, React Query will handle toast and state
    return response.data;
  }

  throw new Error("Restore failed");
}

export async function handleMove(file, token, destinationFolderId) {
  if (!file) return;

  const payload = {
    type: "move",
    item_type: file?.item_type || "file",
    id: file?.id,
    destination_folder_id:
      destinationFolderId === 2 ? null : destinationFolderId,
  };

  try {
    const response = await invokePostApi(token, "upload/", payload);

    if (response?.status === 200 || response?.status === 201) {
      return response.data;
    }
    if (response?.response?.status === 400) {
      throw new Error(
        response?.response?.data?.message ||
          "Something went wrong while moving file",
      );
    }
    throw new Error("Something went wrong while moving file");
  } catch (error) {
    if (error?.response) {
      throw new Error(
        error?.response?.data?.message ||
          "Something went wrong while moving file",
      );
    }

    // ✅ Already thrown error (like above)
    throw error;
  }
}

export const getFileActions = ({ row, handlers, isBin = false }) => {
  const {
    favourite,
    download,
    openRename,
    openDelete,
    openMove,
    restoreFile,
    folderDownload,
  } = handlers;


  if (isBin) {
    return [
      { ...RestoreAction, onClick: (r) => restoreFile(r) },
      { ...DeleteAction, onClick: (r) => openDelete(r) },
    ];
  }

  const favouriteAction = row?.is_favorite
    ? ActiveFavouriteAction
    : FavouriteAction;

  const type = row?.["upload_type"] || "Generated";

  const baseActions = [
    {
      ...favouriteAction,
      onClick: (r) => favourite(r),
    },
    {
      ...DownloadAction,
      onClick: (r) =>
        row?.item_type === "folder" ? folderDownload(r) : download(r),
    },
  ];

  if (type === "Generated") {
    return baseActions;
  }

  if (type === "Manual") {
    return [
      {
        ...EditAction,
        onClick: (r) => openRename(r),
      },
      ...baseActions.slice(0, 1), // favourite
      {
        ...MoveAction,
        onClick: (r) => openMove(r),
      },
      {
        ...DeleteAction,
        onClick: (r) => openDelete(r),
      },
      baseActions[1], // download
    ];
  }

  return [];
};
